import { ValidatorFn, ValidationErrors, UntypedFormGroup } from '@angular/forms';
import { IScheduleCalendar } from '../../interfaces/schedule-calendar.interface';
import { DateTransform } from '@app/shared/utils/date.transform';

export function targetDateRangeValidator(component: IScheduleCalendar): ValidatorFn {
  return (group: UntypedFormGroup): ValidationErrors | null => {
    const value = group.value;
    const startDate = new Date(value.StartDate);
    const endDate = new Date(value.EndDate);
    // component.forbiddenDates  - this is a fix for a bug with non-updated variable
    const forbiddenDates = component.updateAndGetForbiddenDates();

    if (!value.StartDate || !value.EndDate) {
      return null;
    }

    const isForbidden = forbiddenDates.some((range) => {
      if (!range.StartDate || !range.EndDate) {
        return false;
      }

      const rangeStartDate = new Date(range.StartDate);
      const rangeEndDate = new Date(range.EndDate);

      return (
        (DateTransform.isSameOrBefore(rangeStartDate, startDate) &&
          DateTransform.isSameOrBefore(startDate, rangeEndDate)) ||
        (DateTransform.isSameOrBefore(rangeStartDate, endDate) &&
          DateTransform.isSameOrBefore(endDate, rangeEndDate)) ||
        (DateTransform.isSameOrBefore(startDate, rangeStartDate) &&
          DateTransform.isSameOrBefore(rangeStartDate, endDate)) ||
        (DateTransform.isSameOrBefore(startDate, rangeEndDate) && DateTransform.isSameOrBefore(rangeEndDate, endDate))
      );
    });

    if (isForbidden) {
      group.markAsDirty();
      return { usedDateRangeError: true };
    }

    return null;
  };
}
